import { Box } from '@mui/material';
import React from 'react';
import Typography from '@ui/Typography';

export default function ErrorContent({ message }: { message: string }) {
  return (
    <Box pt={6} display="flex" justifyContent="center">
      <Typography variant="h2" color="tertiary">
        {message}
      </Typography>
    </Box>
  );
}
